// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2jhg7","balanceDisclaimer":"posDashboard_balanceDisclaimer__1Yx6r"};